import { PIMButton } from './PIMButton';

export default PIMButton;
export type { PIMButtonColor } from './PIMButton';
